import { render, staticRenderFns } from "./NovosClientes.vue?vue&type=template&id=d4430ece"
import script from "./NovosClientes.vue?vue&type=script&lang=js"
export * from "./NovosClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports